// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"styles_gridContainer__3R45c","modalWidth":"styles_modalWidth__3EqL-","proposalColumn":"styles_proposalColumn__1YimW"};